import React from "react";

const formatTimeAgo = (date) => {
  const now = new Date();
  const diffInSeconds = Math.floor((now - new Date(date)) / 1000);

  // Check if the time difference is valid
  if (!isFinite(diffInSeconds)) {
    return "Invalid time";
  }

  const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });

  // Seconds
  if (diffInSeconds < 60) {
    return rtf.format(-diffInSeconds, "second");
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  // Minutes
  if (diffInMinutes < 60) {
    return rtf.format(-diffInMinutes, "minute");
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  // Hours
  if (diffInHours < 24) {
    return rtf.format(-diffInHours, "hour");
  }

  const diffInDays = Math.floor(diffInHours / 24);
  // Days
  if (diffInDays < 30) {
    return rtf.format(-diffInDays, "day");
  }

  const diffInMonths = Math.floor(diffInDays / 30);
  // Months
  if (diffInMonths < 12) {
    return rtf.format(-diffInMonths, "month");
  }

  const diffInYears = Math.floor(diffInMonths / 12);
  // Years
  return rtf.format(-diffInYears, "year");
};

const FormatTime = ({ createdAt }) => {
  return <>{formatTimeAgo(createdAt)}</>;
};

export default FormatTime;
